import { render, staticRenderFns } from "./View.vue?vue&type=template&id=4b09d4ca&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=4b09d4ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09d4ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b09d4ca')) {
      api.createRecord('4b09d4ca', component.options)
    } else {
      api.reload('4b09d4ca', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=4b09d4ca&scoped=true", function () {
      api.rerender('4b09d4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/banner/View.vue"
export default component.exports